export enum OnyxFilterOperator {
  EQ = 'eq',
  IN = 'in',
  INCLUDES = 'includes',
  EXCLUDES = 'excludes',
  LT = 'lt',
  GT = 'gt',
  GTE = 'gte',
  LTE = 'lte',
  RANGE = 'range',
  NULL = 'null',
}

export enum OnyxFilterFieldVariant {
  DROPDOWN_SINGLE = 'dropdown-single',
  DROPDOWN_MULTI = 'dropdown-multi',
  TABS = 'tabs',
  FREETEXT = 'freetext',
  NUMBER = 'number',
  DATE = 'date',
}
